export default {
  lookups: state => state.lookups,
  lookupsZeus: state => state.lookupsZeus,
  groups: state => state.groups,
  timeZones: state => state.timeZones,
  insuranceCompanies: state => state.insuranceCompanies
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/getters.js